import React from 'react';
import { Tag } from 'antd';
import { StatusEnum } from '../../enums/status';

interface StatusBadgeProps {
  status?: boolean
}
const StatusBadge: React.FC<StatusBadgeProps> = (props) => {
  const { status } = props;
  const statusLabel = {
    color: '',
    name: '',
  };
  if (status) {
    statusLabel.color = 'green';
    statusLabel.name = StatusEnum.displayStatus.active;
  } else {
    statusLabel.color = 'default';
    statusLabel.name = StatusEnum.displayStatus.inActive;
  }
  return (
    <Tag
      color={statusLabel.color}
      style={{
        width: '85px',
        textAlign: 'center',
        fontSize: '10px',
        fontWeight: 'bold',
        lineHeight: '22px',
        height: '24px',
        margin: 0,
      }}
    >
      {statusLabel.name}
    </Tag>
  );
};

StatusBadge.defaultProps = {
  status: true,
};

export default StatusBadge;
